export type MaintenanceConfig = {
  enabled: boolean;
  title?: string;
  message?: string;
};

const getMaintenanceUrl = () => {
  const publicPath = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const url = new URL(`${publicPath}/maintenance.json`, window.location.origin);

  // A unique query string also bypasses intermediary caches and older workers.
  url.searchParams.set("t", Date.now().toString());
  return url.toString();
};

const optionalString = (value: unknown) => {
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
};

export const fetchMaintenanceConfig = async (
  signal?: AbortSignal
): Promise<MaintenanceConfig | null> => {
  try {
    const response = await fetch(getMaintenanceUrl(), {
      cache: "no-store",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      signal,
    });

    if (!response.ok) {
      return null;
    }

    const payload: unknown = await response.json();
    if (
      !payload ||
      typeof payload !== "object" ||
      typeof (payload as { enabled?: unknown }).enabled !== "boolean"
    ) {
      return null;
    }

    const config = payload as Record<string, unknown>;
    return {
      enabled: config.enabled as boolean,
      title: optionalString(config.title),
      message: optionalString(config.message),
    };
  } catch (error) {
    if ((error as Error).name !== "AbortError") {
      console.warn("Unable to check maintenance mode", error);
    }
    return null;
  }
};
